import jsPDF from 'jspdf';
import Papa from 'papaparse'; // librería segura para CSV/Excel
import autoTable from "jspdf-autotable";

export interface CierreExportable {
  idCierreAgente: number;
  usuario: string;
  agente: string;
  fecha: Date | string;
  hora: string;
  fechaCierre: Date | string;
  saldoEnCaja: number;
  saldoBoletas: number;
  saldoSistema: number | null;
  estado: string;
  sobregirado: boolean;
  diferencia: number | null;
  version: number;
}

//Exportar Cierres a CSV
export function exportarCierresExcel(cierres: CierreExportable[]) {
  const datosExportacion = cierres.map((cierre) => ({
    'ID': "#CA-" + cierre.idCierreAgente,
    'USUARIO': cierre.usuario,
    'AGENTES': cierre.agente,
    'FECHA': (cierre.fecha).toString().slice(0,10).split("-").reverse().join("/"),
    'HORA': cierre.hora,
    'Saldo EN CAJA': `Q${cierre.saldoEnCaja.toFixed(2)}`,
    'BOLETA BANCARIA': `Q${cierre.saldoBoletas.toFixed(2)}`,
    'SALDO SISTEMA': cierre.saldoSistema !== null ? `Q${cierre.saldoSistema.toFixed(2)}` : 'Pendiente',
    'ESTADO': cierre.estado,
    'SOBREGIRADO': cierre.sobregirado ? 'Sobregirado' : 'No aplica',
    'DIFERENCIA': cierre.diferencia !== null ? `Q${cierre.diferencia.toFixed(2)}` : 'N/A',
    'EDICIONES': cierre.version,
  }));

  // Generar CSV usando papaparse
  const csv = Papa.unparse(datosExportacion, {
    header: true,
    delimiter: ';'
    //dynamicTyping: false,
    //encoding: 'UTF-8'
  });

  // Agregar BOM para que Excel interprete bien los caracteres UTF-8
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
  
  // Crear descarga
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `reporte-cierres-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}